import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";

export default function getLineSymbol({
  markupLineColor,
  markupLineStyle,
  markupLineWidth,
}) {
  const pointSymbol = new SimpleLineSymbol({
    color: markupLineColor,
    style: markupLineStyle,
    width: markupLineWidth,
  });
  return pointSymbol;
}
